import React from 'react';
import { Dropdown } from 'src/pages/OfferPage/DocuSectionButtons/Dropdown';
import { MenuButtonText } from 'src/pages/OfferPage/DocuSectionButtons/MenuButtonText';
import { NewFeature } from 'src/pages/OfferPage/NewFeature/NewFeature';
import {
  SECTION_BUTTON_FLOOR_PREFIX,
  SECTION_BUTTON_FLOOR_ROOMS_PREFIX,
  SECTION_BUTTON_ROOM_PREFIX,
  SectionButtonDescriptor
} from 'src/pages/OfferPage/DocuSectionButtons/docuSectionButtonDefs';
import { OptionImage } from 'src/pages/OfferPage/DocuSectionButtons/OptionImage';
import { ToggleSwitch } from 'src/pages/OfferPage/DocuSectionButtons/ToggleSwitch';
import { useAppDispatch } from 'src/app/hooks';
import { ProjectQuoteFloorVisibility, toggleDropdownOpened } from 'src/api/project-quote-ui-slice';

export const SectionButton = (
    {
      buttonDesc,
      hasDropdown,
      floorVisibilities,
      isHighlighted,
      setHighlightedBtn
    }
    : {
      buttonDesc: SectionButtonDescriptor,
      hasDropdown: boolean,
      floorVisibilities: ProjectQuoteFloorVisibility[],
      isHighlighted: boolean
      setHighlightedBtn: any
    }) => {
  // const {
  //   hasDropdown,
  //   isDropdownActive,
  //   onDropdownClick = () => {},
  //   isHighlighted,
  //   btn,
  // } = props;

  const dispatch = useAppDispatch();

  const onClick = React.useCallback(() => {

    setHighlightedBtn(buttonDesc)

    if (buttonDesc.contentCssSelector == null) {
      return;
    }
    const elem = document.querySelector(buttonDesc.contentCssSelector);

    if (elem) {
      elem.scrollIntoView({behavior: "smooth"});
    }
  }, [buttonDesc]);

  return (
      <div
          className={`docu-jmp-btn-cont not-rounded ${
              buttonDesc.enabled ? "" : "disabled"
          }`}
          style={{
            opacity: buttonDesc.enabled ? "" : 0.3,
            borderLeft: isHighlighted
                ? "2px solid var(--uplan-blue-darker-1)"
                : "2px solid transparent",
            marginLeft: buttonDesc.buttonId.startsWith(SECTION_BUTTON_ROOM_PREFIX) ||
            buttonDesc.buttonId.startsWith(SECTION_BUTTON_FLOOR_ROOMS_PREFIX) ? 18 : undefined,
            animation: (buttonDesc.type === 'room' || buttonDesc.type === 'floor_rooms')
                ? "fadein 0.2s ease" : undefined,
            minHeight: "40px"
          }}
      >
        <div
            className={`docu-jmp-btn not-rounded ${
                isHighlighted ? " docu-jmp-btn-highlighted" : ""
            }`}
            onClick={() => onClick()}
            style={{
              cursor: buttonDesc.enabled ? "pointer" : "not-allowed",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flex: 1,
            }}
        >
          <OptionImage icon={buttonDesc.icon} isTest={buttonDesc.testFeature}/>
          <MenuButtonText
              isHighlighted={isHighlighted}
              padding={"0 10px"}
              fontWeight={400}
              wordBreak={"break-word"}
              tooltip={buttonDesc.label}
          />
        </div>
        {hasDropdown && (
            <Dropdown
                dropdownActive={isDropDownActive(buttonDesc, floorVisibilities)}
                onDropdownClick={() => dispatch(toggleDropdownOpened(buttonDesc.floorId!!))}
            />
        )}
        {buttonDesc.newFeature ? <NewFeature/> : null}
        {buttonDesc.enabled && buttonDesc.toggleable ? <ToggleSwitch buttonDesc={buttonDesc}/> : null}
      </div>
  );
};

function isDropDownActive(desc: SectionButtonDescriptor, floorVisibilities: ProjectQuoteFloorVisibility[]): boolean {
  if (desc.buttonId.startsWith(SECTION_BUTTON_FLOOR_PREFIX)) {
    return floorVisibilities.find((floorVisibility) => floorVisibility.floorId === desc.floorId)!!.dropDownOpened
  } else {
    return false;
  }
}
